import { render } from "./CreateEditUser.vue?vue&type=template&id=3d71de5c"
import script from "./CreateEditUser.vue?vue&type=script&lang=js"
export * from "./CreateEditUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__